<template>
  <div class="workflow-goals">
    <goal-list
      ref="goalList"
      placeholder="You have not added any goals in this workflow yet."
      :disabled="disabled"
      :goals="workflow.goals"
      @changed="updateGoals"
    >
    </goal-list>
    <v-btn :disabled="disabled" @click="userAddGoal" icon="mds:add"/>
  </div>
</template>

<script>
import GoalList from '@/components/GoalList.vue'
import workflowApi from '@/api/workflowApi'

export default {
  name: 'WorkflowGoals',
  props: {
    workflow: Object
  },
  components: {
    GoalList
  },
  computed: {
    disabled () {
      return this.$store.state.isWorkflowDisabled
    }
  },
  methods: {
    userAddGoal () {
      this.$refs.goalList.userAddGoal()
    },

    async updateGoals (goals, updateNote, isNewGoal) {
      await workflowApi.updateWorkflowMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          status: this.status,
          expectedVersion: this.workflow.version,
          goals,
          updateNote
        }
      )
    }
  }
}
</script>
